export default __webpack_public_path__ + "static/media/plan your visit warning icons.f2345989.png";